import { style } from '@do/walrus';
import styled from 'styled-components';
import vars from '../assets/overwrite-vars';

const CreditBanner = styled.div`
  width: 100%;
  background: ${vars.green_lightest};
  padding: ${style.vars.whitespace.regular} ${style.vars.whitespace.large};
  border-bottom: ${style.vars.borderWidth.thin} solid ${vars.green_darkest};
  position: fixed;
  display: flex;
  flex-direction: row;
  justify-content: center;
  z-index: 100;
  margin-top: ${vars.header_height} !important;

  span {
    margin-left: 14px;
  }

  @media screen and (max-width: 1150px) {
    flex-direction: column;

    span {
      margin-left: 0;
    }
  }

  strong {
    font-family: 'JetBrains Mono', sans-serif;
    font-size: ${style.vars.fontSize.small};
    line-height: ${style.vars.height.xsmall};
    font-weight: 800;
    letter-spacing: 1px;
    font-feature-settings: 'ordn' on, 'case' on;
  }
`;

export const AmdCreditBanner = styled(CreditBanner)`
  background: ${vars.grey_light};
`;
export default CreditBanner;
